import Concept from './Concept';
export default Concept;
